import WithdrawalsApiService from "@/core/services/api.service.withdrawals";
import { EventBus, EVENTS } from "@/core/services/event-bus";

export default {
  name: "WithdrawalsDashboard",
  data() {
    return {
      loading: false,
      dateFilter: null,
      dateMenu: false,
      dashboardData: {
        totalSum: 0,
        totalWithdrawableUsers: 0,
        totalWithdrawableSum: 0,
        totalSumByStatus: {
          ReturnedToWallet: {
            totalSum: 0,
            totalOperations: 0,
            totalWithdrawableUsers: 0
          },
          SendedToBank: {
            totalSum: 0,
            totalOperations: 0,
            totalWithdrawableUsers: 0
          },
          Processing: {
            totalSum: 0,
            totalOperations: 0,
            totalWithdrawableUsers: 0
          },
          Paid: {
            totalSum: 0,
            totalOperations: 0,
            totalWithdrawableUsers: 0
          }
        }
      }
    };
  },
  computed: {
    statusTitleMap() {
      return {
        Processing: "Processing",
        Paid: "Paid",
        SendedToBank: "Sent to Bank",
        ReturnedToWallet: "Returned to Wallet"
      };
    },
    statusCards() {
      return Object.keys(this.dashboardData.totalSumByStatus).map(statusKey => {
        const statusData = this.dashboardData.totalSumByStatus[statusKey];
        const config = this.getStatusConfig(statusKey);

        return {
          title: this.statusTitleMap[statusKey] || statusKey,
          value: statusData?.totalSum || 0,
          operations: statusData?.totalOperations || 0,
          users: statusData?.totalWithdrawableUsers || 0,
          color: config.color,
          icon: config.icon
        };
      });
    },
    formattedTotalSum() {
      return this.formatCurrency(this.dashboardData.totalSum);
    },
    formattedTotalWithdrawableSum() {
      return this.formatCurrency(this.dashboardData.totalWithdrawableSum);
    },
    totalWithdrawableUsersCount() {
      return this.dashboardData.totalWithdrawableUsers;
    },
    formattedDate: {
      get() {
        if (!this.dateFilter) return null;
        const date = new Date(this.dateFilter);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        });
      },
      set(value) {
        // This setter is needed for v-model but we don't need to implement it
        // since the date picker handles the dateFilter directly
      }
    }
  },
  async mounted() {
    await WithdrawalsApiService.init().then(() => {
      this.loadDashboardData();
    });

    // Listen for refresh events from Subheader
    EventBus.$on(EVENTS.REFRESH_WITHDRAWALS_DASHBOARD, this.handleRefreshEvent);
  },

  beforeDestroy() {
    // Clean up event listener
    EventBus.$off(EVENTS.REFRESH_WITHDRAWALS_DASHBOARD, this.handleRefreshEvent);
  },
  methods: {
    getStatusConfig(statusKey) {
      const configs = {
        Processing: {
          color: "warning",
          icon: "mdi-clock-outline"
        },
        Paid: {
          color: "success",
          icon: "mdi-check-circle"
        },
        SendedToBank: {
          color: "primary",
          icon: "mdi-bank"
        },
        ReturnedToWallet: {
          color: "orange",
          icon: "mdi-wallet"
        }
      };

      return (
        configs[statusKey] || {
          color: "secondary",
          icon: "mdi-help-circle"
        }
      );
    },
    async loadDashboardData() {
      this.loading = true;
      try {
        const dateTimeParam = this.dateFilter ? this.formatDateForAPI(this.dateFilter) : null;
        const response = await WithdrawalsApiService.getWithdrawDashboard(dateTimeParam);
        this.dashboardData = response.data;
      } catch (error) {
        console.error("Error loading dashboard data:", error);
        this.$toast.error("Failed to load dashboard data");
      } finally {
        this.loading = false;
      }
    },
    formatDateForAPI(date) {
      // Convert date (YYYY-MM-DD) to ISO DateTime string
      const dateObj = new Date(date + "T00:00:00.000Z");
      return dateObj.toISOString();
    },
    applyDateFilter() {
      this.loadDashboardData();
    },
    clearDateFilter() {
      this.dateFilter = null;
      this.loadDashboardData();
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2
      }).format(amount || 0);
    },
    async refreshDashboard() {
      await this.loadDashboardData();
    },

    handleRefreshEvent() {
      // Handle refresh event from Subheader
      this.loadDashboardData();
    }
  }
};
